// extracted by mini-css-extract-plugin
export default {"formTextareaBox":"index_formTextareaBox_zgWY0","formTextarea":"index_formTextarea_dwcM1","formTextareaWord":"index_formTextareaWord_V06OR","redSize":"index_redSize_e6vcC"};